"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsBreadcrumbNavigate = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsBreadcrumbNavigate component displays breadcrumb navigation
 * with customizable text color for current and parent routes,
 * and customizable dividers with different shapes.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} [props.currentRouteColor] - Custom color for the current route.
 * @param {string} [props.parentRouteColor] - Custom color for the parent routes.
 * @param {string} [props.dividerShape] - Custom shape for the divider (e.g., '/', '->', '.', ':', '|').
 * @param {Object} [props.sx] - Custom styles applied to the text.
 * @returns {JSX.Element} Breadcrumb navigation component.
 */
const DmsBreadcrumbNavigate = _ref => {
  let {
    currentRouteColor,
    parentRouteColor,
    dividerShape = '/',
    sx
  } = _ref;
  const location = (0, _reactRouterDom.useLocation)();
  const [breadcrumbs, setBreadcrumbs] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    const createBreadcrumbs = pathname => {
      return pathname.split('/').filter(Boolean).map((segment, index, segments) => ({
        label: segment.charAt(0).toUpperCase() + segment.slice(1),
        route: "/".concat(segments.slice(0, index + 1).join('/'))
      }));
    };
    setBreadcrumbs(createBreadcrumbs(location.pathname));
  }, [location]);
  const getDividerShape = () => {
    switch (dividerShape) {
      case '->':
        return /*#__PURE__*/_react.default.createElement(_material.Typography, {
          variant: "body2",
          sx: {
            color: 'white'
          }
        }, "\u2192");
      case '.':
        return /*#__PURE__*/_react.default.createElement(_material.Typography, {
          variant: "body2",
          sx: {
            color: 'white'
          }
        }, ".");
      case ':':
        return /*#__PURE__*/_react.default.createElement(_material.Typography, {
          variant: "body2",
          sx: {
            color: 'white'
          }
        }, ":");
      case '|':
        return /*#__PURE__*/_react.default.createElement(_material.Typography, {
          variant: "body2",
          sx: {
            color: 'white'
          }
        }, "|");
      case '/':
      default:
        return /*#__PURE__*/_react.default.createElement(_material.Typography, {
          variant: "body2",
          sx: {
            color: 'white'
          }
        }, "/");
    }
  };
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: sx
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: true
  }, breadcrumbs.length > 0 && /*#__PURE__*/_react.default.createElement(_material.Breadcrumbs, {
    "aria-label": "breadcrumb",
    separator: getDividerShape()
  }, breadcrumbs.map((item, index) => /*#__PURE__*/_react.default.createElement(_material.Typography, {
    key: item.route,
    color: index === breadcrumbs.length - 1 ? currentRouteColor || 'white' : parentRouteColor || 'rgba(255, 255, 255, 0.7)'
  }, item.label))))));
};
exports.DmsBreadcrumbNavigate = DmsBreadcrumbNavigate;
DmsBreadcrumbNavigate.propTypes = {
  currentRouteColor: _propTypes.default.string,
  parentRouteColor: _propTypes.default.string,
  dividerShape: _propTypes.default.oneOf(['/', '->', '.', ':', '|']),
  sx: _propTypes.default.object
};